import FlashcardUsage from 'Images/flashcard_usage.gif'
import { Image, Text } from '@redriverpress/system'

export default function FlashcardInstructions() {
  return (
    <>
      <Image
        src={FlashcardUsage}
        width='10rem'
        height='auto'
        mb={3}
        alt='An animation showing a flashcard image and text being shown and hidden using the instructions given below.'
      />
      <Text fontWeight={600}>
        Click on the image to show or hide the&nbsp;text.
      </Text>
      <Text fontWeight={600} mt={3}>
        Click on the text to show or hide the&nbsp;image.
      </Text>
    </>
  )
}
